"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line complexity
function compileLogoStyleString(branding) {
    const { logo = {} } = branding;
    const { maxWidth, maxHeight, padding, paddingMobile, position, opacity } = logo;
    return `
        {
            ${maxWidth ? `--logo-max-width: ${maxWidth};` : ''}
            ${maxHeight ? ` --logo-max-height: ${maxHeight};` : ''}
            ${padding ? ` --logo-padding: ${padding};` : ''}
            ${paddingMobile ? ` --logo-padding-mobile: ${paddingMobile};` : ''}
            ${position ? ` --logo-position: ${position};` : ''}
            ${opacity || opacity === 0 ? ` --logo-opacity: ${opacity};` : ''}
        }
    `;
}
exports.default = compileLogoStyleString;
